<template>
  <el-dialog  :visible.sync="showDialogVal" append-to-body custom-class="pageLayout-style">
    <div slot="title" class="verticallyCenter dialog-title">
      <span class="dialog-name">选择样式</span>
      <div class="flex1 textCenter">
        <el-input class="search-inp " placeholder="搜索" v-model="searchName"  @focus="getFocus($event)" @blur="blurEvent($event)" @keydown.native="keyDownEvent">
          <template slot="suffix">
            <span class="icon icon-portal-search" @click="selectTemplate"></span>
          </template>
        </el-input>
      </div>
    </div>
    <div class="list-box">
      <div class="left">
        <ul class="left-types-list">
          <li
            class="types-list-li"
            v-for="(type, index) in typeLists"
            :key="index"
            @click="changeStyleType(type.encId, index)"
            :class="[activeId === index ? 'active' : '']"
          >
            <div class="verticallyCenter types-list-li-content">
              <span class="flex1 font600">{{ type.name }}</span>
              <span class="count font400">{{ type.count }}</span>
            </div>
            <span class="topping-style" v-if="collectTypeId === type.encId && index === 0 "></span>
          </li>
        </ul>
      </div>
      <div class="right" ref="styleWrap">
        <el-scrollbar ref="scrollbar" style="height: 100%">
          <div class="empty-data" v-if="styleDatas.length === 0">
            <span v-if="loadingData" class="icon-portal-loading1"></span>
            <p v-else>没有数据</p>
          </div>
          <div v-else class="style-datas" ref="styleDatas">
            <waterfall :col="col" :data="styleDatas" :lazy-distance="20" :load-distance="200">
              <div
                class="style-data-li"
                v-for="(item, index) in styleDatas"
                :key="index"
                @click="selectStyle(item, index)"
                :class="activeIndex === index ? 'active' : ''"
              >
                <div class="img-box">
                  <img :src="item.cover ? item.cover : defaultImg" alt="" />
                </div>
                <span
                  v-if="hasDelPermission && styleDatas.length > 0"
                  class="delete-icon"
                  @mousedown.stop
                  @click.stop="delComponent(item)"
                ><i class="icon icon-portal-delete"></i
                ></span>
                <div class="verticallyCenter template-info">
                  <p class="overflowHid1 flex1">{{ item.name || item.title }}</p>
                  <span class="component-name-box">{{getStyleNo(item)}}</span>
                </div>
              </div>
            </waterfall>
          </div>
        </el-scrollbar>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { data_dictionary_map } from "root/static/dataDictionary.js"
import instance from "../../../interceptor"
import { getModulesList } from "@/utils/initEv.js"
import { decrypt } from "utils"
import { reverseBuildModel } from "utils/reverseBuildModel.js"
import {
  _throttle,
  _debounce,
  isExist,
  getAllRectInNewLayout,
  smartMathMax
} from "../../../utils/index"
import { deepCloneAndFreeze } from "utils/revork"
import { editAnimateAddLayout } from "../../../utils/event/animate"
import { v1 } from 'uuid'
const uuid = { v1 }
export default {
  name: "styles-list",
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    curPageLayoutIndex: {
      type: Number,
      required: true
    },
    pageLayoutList: {
      type: Array,
      required: true
    },
    id: {
      type: [Number, String],
      required: true
    },
    twoTypeId: {
      type: [Number, String],
      required: false
    }
  },
  computed: {
    isSubHeadPage() {
      return this.$store.state[this.request_prefix].page.isSubHeadPage
    },
    hasDelPermission() {
      let userPermissionCode = this.$store.state.states.userPermission
      return Array.isArray(userPermissionCode) && userPermissionCode?.indexOf(12) > -1 ? true : false
    },
    collectTypeId(){
      return this.typeLists.find(item=>item.name?.indexOf("我的")>-1)?.encId
    },
    showDialogVal: {
      get() {
        return this.showDialog
      },
      set(val) {
        this.$emit("update:showDialog", val)
      }
    },
    isWaterFall() {
      return this.$store.state[this.request_prefix].page.isWaterFall === "waterFall" ? true : false
    },
    getStyleNo(){
      return function(styles){
        const DEFAULTLEN = 4
        let prefixO =''
        if(styles.seq){
          const seq = styles.seq.toString()
          // 不足四位需要补齐
          const diffLen = DEFAULTLEN - seq.length
          for(let i=0;i<diffLen;i++){
            prefixO=prefixO+'0'
          }
        }
        let prefix =  this.typeLists.find(item=>item.id === styles.typeId)?.prefix
        return `${prefix}${prefixO}${styles.seq}`
      }
    },
  },
  mounted() {
    this.getPageLayoutTypes()
    this.$nextTick(() => {
      this.listenerScroll()
    })
    this.styleCol()
    window.addEventListener("resize", this.styleCol)
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.styleCol)
  },
  data() {
    return {
      defaultImg: require("../../../assets/images/default_image_home.png"),
      activeId: 1,
      activeIndex: null,
      allStyles: [],
      styleDatas: [],
      typeLists: [],
      totalPage: 1,
      curPage: 1,
      pageNum: 20, //每页数量
      col: 3,
      newRectIds: [],
      newRectLen: 0, //新增通栏中组件的个数
      hasAddedLen: 0,
      lastClick: undefined,
      loadingData: false,
      searchName:'',
      isFocus: false
    }
  },
  methods: {
    getFocus(event){
      this.isFocus = true
      event.currentTarget.select()
    },
    blurEvent(){
      this.isFocus = false
    },
    keyDownEvent(){
      let key = window.event.keyCode
      //enter键  待完善
      if (key === 13 ) {
        this.selectTemplate()
      }
    },
    selectTemplate(){
      this.curPage = 1
      // 搜索的时候需要重新调用分类统计接口
      this.styleDatas=[]
      this.getPageLayoutTypes(true,this.styleId)
      this.getStyles()
    },
    listenerScroll() {
      let _this = this
      _this.$refs.scrollbar.wrap.onscroll = e => {
        let height = e.target.scrollHeight - e.target.clientHeight
        if (
          (height == e.target.scrollTop || height - e.target.scrollTop === 1) &&
          height != 0 &&
          _this.curPage < _this.totalPage
        ) {
          _this.curPage = _this.curPage + 1
          _this.$API
            .queryComponentList({
              typeId: _this.styleId,
              p2: _this.pageNum,
              p: _this.curPage,
              k: this.searchName
            })
            .then(res => {
              _this.styleDatas = _this.styleDatas.concat(res.data?.data?.PageInfo?.list)
            })
        }
      }
    },
    delComponent(param) {
      const self = this
      if (param.encId) {
        this.$confirm("确认删除吗？", "", {
          confirmButtonText: "继续",
          cancelButtonText: "取消",
          showClose: false,
          dangerouslyUseHTMLString: "<p>确认删除吗？</p>",
          iconClass: "bigScreen_confirm_icon el-icon-warning",
          cancelButtonClass: "bigScreen_confirm_cancel_button",
          confirmButtonClass: "bigScreen_confirm_button",
          customClass: "bigScreen_confirm custom_warning_dialog"
        })
          .then(() => {
            instance
              .post(`v2/${param.encId}/remove`)
              .then(() => {
                getModulesList.call(self, { id: this.typeId })
                this.changeStyleType(this.styleId, this.activeId)
                this.typeLists[this.activeId].count = this.typeLists[this.activeId].count - 1
              })
              .catch(err => {})
          })
          .catch(() => {})
      }
    },
    async getPageLayoutTypes(isSearch,curStyleId) {
      let menuName = this.request_prefix === "appStage" ? "appMenu" : "menu"
      let otherModuleTypes = this.$store.state[menuName].menu.otherTypes
      const pageLayoutTypeName = this.isWaterFall
        ? this.request_prefix === "appStage"
          ? "新移动端通栏样式"
          : "新通栏样式"
        : "通栏样式"
      let layoutTypes = otherModuleTypes.find(item => item.name.indexOf(pageLayoutTypeName) > -1)
      this.styleId = this.twoTypeId ? this.twoTypeId : layoutTypes?.encId
      this.loadingData = true
      // 再调用一次接口 是因为第一次获取分类树结构的时候未返回数量统计（后端查询太多）
      const res = await this.$API.queryComponentTypeTree({
        pid: this.styleId,
        countSub: true,
        k: this.searchName
      })
      this.typeLists = res.data.data.list?.filter(item => item.name !== "头部通栏" && item.name !== "底部通栏")
      this.styleId = isSearch ? curStyleId : this.typeLists[this.activeId]?.encId
      await this.getStyles()
      this.loadingData = false
    },
    async getStyles() {
      if (!!!this.styleId) {
        return
      }
      const res = await this.$API.queryComponentList({
        typeId: this.styleId,
        p2: this.pageNum,
        k: this.searchName
      })
      this.styleDatas = res.data?.data?.PageInfo?.list
      this.curPage = 1
      this.totalPage = res.data?.data.PageInfo.pages
      // 判断当前样式数量是否小于总数，如果小于总数，并且渲染高度小于弹框高度，此时不能触发滚动加载下一页，需要自动加载下一页
      this.$nextTick(()=>{
        setTimeout(()=>{
          this.isAutoUpdateData()
        },1000)
      })
    },
    isAutoUpdateData(){
      return
      if(this.styleDatas.length === 0){
        return
      }
      const total =  this.typeLists[this.activeId].count
      if(this.styleDatas.length === total ){
        return
      }
      const styleHeight = this.$refs.styleDatas.getBoundingClientRect().height
      const styleWrapHeight = this.$refs.styleWrap.getBoundingClientRect().height - 15  // 底部有15px的空白
      if(styleHeight < styleWrapHeight){
        this.curPage ++
        this.$API
          .queryComponentList({
            typeId: this.styleId,
            p2: this.pageNum,
            p: this.curPage,
            k: this.searchName
          })
          .then(res => {
            this.styleDatas = this.styleDatas.concat(res.data?.data?.PageInfo?.list)
            setTimeout(()=>{
              this.isAutoUpdateData()
            },1000)
          })
      }
    },
    async changeStyleType(styleId, index) {
      this.activeIndex = undefined
      this.activeId = index
      this.styleId = styleId
      this.loadingData = true
      this.styleDatas = []
      await this.getStyles()
      this.loadingData = false
    },
    lockClick() {
      let nowClick = new Date()
      if (this.lastClick === undefined) {
        this.lastClick = nowClick
        return false
      } else {
        if (Math.round(nowClick.getTime() - this.lastClick.getTime()) > 1000) {
          this.lastClick = nowClick
          return false
        } else {
          this.lastClick = nowClick
          return true
        }
      }
    },
    async selectStyle(item, index) {
      // 防止重复点击
      if (this.lockClick()) {
        console.log("重复点击啦")
        return
      }
      // let data = await this.$API.queryComponentContent({
      //   encId: item.encId
      // })
      const { pageId } = this.$store.state.states.getDataPageIds
      let data = await this.$API.queryComponentContentClone({
        encId: item.encId,
        p: pageId,
        k: this.searchName
      })
      // 选择空白布局
      await this.addPageLayout(data, index + 1)

      this.activeIndex = index
      // 延时500ms 关闭弹框
      this.showDialogVal = false
      // setTimeout(() => {
      //   this.showDialogVal = false
      // }, 500)
    },
    // 新增的通栏id 替换
    getNewLayoutId() {
      let id = 1
      this.pageLayoutList.forEach(item => {
        id = item.id && item.id >= id ? item.id + 1 : id
      })
      return id
    },
    async addPageLayout(item, typeIndex) {
      let index = this.curPageLayoutIndex
      let content = JSON.parse(item.data.data.content)
      let rects = content.rects
      this.newRectIds = []
      this.newRectLen = rects.length
      rects.forEach(item => {
        //还原被encryption方法加密过json字符串
        item.c = decrypt(item.c, data_dictionary_map)
        //将json中的rem转为px
        reverseBuildModel(item.c)
      })
      let newLayout = JSON.parse(JSON.stringify(content.pageLayout))
      // 生成栅格唯一id todo
      let gridLayoutIds = []
      console.log("newLayout", newLayout)
      newLayout.layout.rows[0]?.options.gridLayout?.forEach(item=>{
        const newId =  this.uuid.v1()
        gridLayoutIds.push({
          oldId: item.i,
          newId: newId
        })
        item.i = newId
      })
      let inDocument = this.pageLayoutList[index].options.inDocument
      if (inDocument === "header" || inDocument === "relativeHeader") {
        let allRectId = getAllRectInNewLayout([this.pageLayoutList[index]])
          .map(it => it.rects || [])
          .flat(1)
        let navComp = this.$store.state[this.request_prefix].page.children[0].children?.find(item => {
          return allRectId.includes(item.rect_id) && (item.options.innerElement === "cxNavMenu" || item.shape === "cxNavMenu") 
        })
        const navAppId = navComp?.options?.appId || navComp?.options?.myFetchParam?.appId 
        if (navAppId) {
          rects.some(item => {
            if (item?.c?.options?.innerElement === "cxNavMenu" || item?.c?.shape === "cxNavMenu") {
              item?.c?.options && (item.c.options.appId = navAppId)
              return true
            }
          })
        }
      }
      // 有二级分类是从更多进来的 只需切换样式
      if (this.twoTypeId) {
        const before = deepCloneAndFreeze(this.pageLayoutList[index])
        newLayout.id = this.pageLayoutList[index].id
        newLayout = await this.handleRect(newLayout, rects,gridLayoutIds)

        newLayout.options.inDocument = inDocument
        // 子页面切换样式继承isRefHome属性
        newLayout.options.isRefHome = this.pageLayoutList[index]?.options?.isRefHome
        this.pageLayoutList.splice(index, 1, newLayout)
        this.$addHistory({
          type: "update",
          stateType: "updatePageLayout",
          payload: {
            container_id: 0,
            pageLayoutId: newLayout.id
          },
          before,
          data: deepCloneAndFreeze(newLayout)
        })
      } else {
        newLayout.id = this.getNewLayoutId()
        newLayout = await this.handleRect(newLayout, rects,gridLayoutIds)
        // 如果是锚点，则需要先删除之前的锚点
        if (newLayout.options.inDocument === "anchor") {
          let oldAnchorIndex = this.pageLayoutList.findIndex(item => item.options.inDocument === "anchor")
          if (oldAnchorIndex > -1) {
            this.delElementHandle(this.pageLayoutList[oldAnchorIndex])
            this.pageLayoutList.splice(oldAnchorIndex, 1)
          }
        }
        this.pageLayoutList.splice(index + 1, 0, newLayout)
        this.$addHistory({
          type: "add",
          stateType: "addPageLayout",
          payload: {
            container_id: 0,
            pageLayoutId: newLayout.id,
            index: index + 1
          }
        })
      }
      this.$store.dispatch(this.request_prefix + "/changePageLayout", { pageLayoutList: this.pageLayoutList })

      if (!this.twoTypeId) {
        // 激活当前新加入的通栏
        this.$store.commit("states/changeActiveID", { container_id: this.id, pageLayoutId: index + 1 })
        this.$store.commit("states/changeElementType", "cxPageLayout")
      } else {
        if (inDocument === "anchor") {
          this.changeAnchorBtn(this.pageLayoutList, this.pageLayoutList[index])
        }
      }
    },
    delElementHandle(cellVal) {
      let rectIds = cellVal.rectIds ? JSON.parse(JSON.stringify(cellVal.rectIds)) : []
      rectIds.forEach(item => {
        let param = {
          container_id: this.id,
          rect_id: item,
          record: false
        }
        this.$store.dispatch(this.request_prefix + "/deleteElement", param)
      })
      cellVal.layout.rows?.forEach(item => {
        if (item.rectIds && item.rectIds.length > 0) {
          this.delElementHandle(item)
        }
      })
      cellVal.layout.cols?.forEach(item => {
        if (item.rectIds && item.rectIds.length > 0) {
          this.delElementHandle(item)
        }
      })
    },
    async changeAnchorBtn(pageLayoutList, anchorPageLayout) {
      // 排除用fixed定位的通栏、被隐藏的通栏、锚点通栏
      let pageListLen = 0
      pageLayoutList.forEach(pageLayout => {
        let type = pageLayout.options.inDocument
        if (type !== "anchor" && pageLayout.options.position !== "fixed" && pageLayout.options.isShow) {
          pageListLen++
        }
      })
      if (anchorPageLayout.options.inDocument === "anchor") {
        let rectIds = anchorPageLayout?.layout?.rows[0]?.rectIds
        let rectIdsLen = anchorPageLayout?.layout?.rows[0]?.rectIds?.length
        let elementList = []
        if (rectIds) {
          rectIds.forEach(item => {
            elementList.push(
              this.$store.state[this.request_prefix].page.children[0].children.find(rect => rect.rect_id === item)
            )
          })
        }
        if (pageListLen < rectIdsLen - 2) {
          // 减少锚点个数
          let len = rectIdsLen - 2 - pageListLen
          rectIds.splice(pageListLen, len)
        } else if (pageListLen > rectIdsLen - 2) {
          // 添加锚点个数
          let index = rectIdsLen > 2 ? rectIdsLen - 2 : 0
          let len = pageListLen - (rectIdsLen - 2)
          let param = {
            active: false,
            draggable: false,
            hoverZIndex: 1,
            parentLim: true,
            resizable: true,
            shape: "cxButton",
            options: JSON.parse(JSON.stringify(elementList[0]?.options))
          }
          for (var j = 0; j < len; j++) {
            if (Number(index + 1 + j) < 10) {
              param.options.content = "0" + Number(index + 1 + j)
            } else {
              param.options.content = Number(index + 1 + j)
            }
            await this.addNewRect(
              {
                rectAttr: param,
                cellRect: rectIds,
                index: Number(index + j),
                isClone: false
              },
              "",
              "addBtn"
            )
          }
        }
      }
    },
    async handleRect(newLayout, rects,gridLayoutIds) {
      newLayout.layout.rows?.forEach(row => {
        return this.handleRect(row, rects,gridLayoutIds)
      })
      newLayout.layout.cols?.forEach(col => {
        return this.handleRect(col, rects,gridLayoutIds)
      })
      for (let j = 0; j < newLayout?.rectIds?.length; j++) {
        const item = newLayout.rectIds[j]
        for (let i = 0; i < rects.length; i++) {
          if (rects[i].c.rect_id === item) {
            await this.addNewRect({
              rects: rects,
              rectAttr: rects[i].c,
              cellRect: newLayout.rectIds,
              index: j,
              isClone: false,
              gridLayoutIds:gridLayoutIds
            })
          }
        }
      }
      return newLayout
    },
    async addRectInPageLayoutComponent(newLayout, rects, parentRectId) {
      newLayout.layout.rows?.forEach(row => {
        return this.addRectInPageLayoutComponent(row, rects, parentRectId)
      })
      newLayout.layout.cols?.forEach(col => {
        return this.addRectInPageLayoutComponent(col, rects, parentRectId)
      })
      for (let j = 0; j < newLayout?.rectIds?.length; j++) {
        const item = newLayout.rectIds[j]
        for (let i = 0; i < rects.length; i++) {
          if (rects[i].c.rect_id === item) {
            await this.addNewRect({
              rects: rects,
              rectAttr: rects[i].c,
              cellRect: newLayout.rectIds,
              index: j,
              isClone: false,
              parentRectId: parentRectId
            })
          }
        }
      }
      return newLayout
    },
    // 新加入rect
    async addNewRect(param, e, type) {

      let rectAttr = JSON.parse(JSON.stringify(param.rectAttr))
      const uuidRectId = uuid.v1()
      if (this.isSubHeadPage) {
        rectAttr.rect_id = uuidRectId
        rectAttr.options.inSubHead = true
      }
      if (isExist(rectAttr.options.parentRectId) && isExist(param.parentRectId)) {
        rectAttr.options.parentRectId = param.parentRectId
      }
      let newGridLayoutId
      if(param.gridLayoutIds &&  param.gridLayoutIds.length>0){
        newGridLayoutId = param.gridLayoutIds?.find(item=>item.oldId === rectAttr.i)?.newId
        rectAttr.i = newGridLayoutId
      }
      let oldRectId = rectAttr.rect_id
      // 如果当前数据中存在appId判断当前组件是否是系统保存好的样式
      if (rectAttr.options.myFetchParam?.appId || rectAttr.options.appId) {
        //更新appid
        const appId = rectAttr.options.appId ? rectAttr.options.appId : rectAttr.options.myFetchParam?.appId
        // 需要判断当前组件类型，如果是基于自由布局开发的搜索组件/导航菜单，需要特殊处理
        const isSearchComponent = rectAttr.options.pluginName?.includes("searchComponentPlugin")
        const isNavComponent = rectAttr.shape.toLowerCase().includes("nav")
        // const res = await this.$styleToSaveModule(
        //   "31CB73E03E24BBFF",
        //   "临时",
        //   appId,
        //   param.isClone,
        //   isSearchComponent,
        //   isNavComponent
        // )
        // console.log("新加入rect", res)
        if (!!appId) {
          const uuidRectId = uuid.v1()
          if (this.isSubHeadPage) {
            rectAttr.rect_id = uuidRectId
            rectAttr.options.inSubHead = true
          }
          // 没有myfetchparam的组件 比如搜索组件 更新appId
          rectAttr.options.appId = appId
          const params = {
            containerID: this.id,
            data: rectAttr,
            ignoreAnimate: true // 此处的动画关系 需要在所有的组件都加入之后再处理
          }
          this.$store.dispatch(this.request_prefix + "/addElement", params).then(res => {})

          let newIndex = param.index
          const allRects = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
            container_id: this.id
          }).children
          let _rect_id = -1
          if (allRects.length > 0) {
            _rect_id = smartMathMax(
              ...allRects.map(function (o) {
                return o.rect_id
              })
            )
          }
          let rect_id = _rect_id
          if (this.isSubHeadPage) {
            rect_id = uuidRectId
          }
          if (typeof newIndex !== "undefined") {
            param.cellRect.splice(newIndex, 1, rect_id)
          } else {
            param.cellRect.push(rect_id)
          }
          this.newRectIds.push({
            oldRectId: oldRectId,
            newRectId: rect_id
          })
        }
      } else {
        const uuidRectId = uuid.v1()
        if (this.isSubHeadPage) {
          rectAttr.rect_id = uuidRectId
          rectAttr.options.inSubHead = true
        }
        const params = {
          containerID: this.id,
          data: rectAttr,
          ignoreAnimate: true // 此处的动画关系 需要在所有的组件都加入之后再处理
        }
        this.$store.dispatch(this.request_prefix + "/addElement", params)
        let newIndex = param.index
        const allRects = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
          container_id: this.id
        }).children
        let _rect_id = -1
        if (allRects.length > 0) {
          _rect_id = smartMathMax(
            ...allRects.map(function (o) {
              return o.rect_id
            })
          )
        }
        let rect_id = _rect_id
        if (this.isSubHeadPage) {
            rect_id = uuidRectId
          }
        if (type === "addBtn" && typeof newIndex !== "undefined") {
          // 添加锚点按钮逻辑
          param.cellRect.splice(newIndex, 0, rect_id)
        } else {
          if (typeof newIndex !== "undefined") {
            param.cellRect.splice(newIndex, 1, rect_id)
          } else {
            param.cellRect.push(rect_id)
          }
          this.newRectIds.push({
            oldRectId: oldRectId,
            newRectId: rect_id
          })
        }
      }

      this.hasAddedLen++
      if (this.hasAddedLen === this.newRectLen) {
        //所有的组件都替换到最新的rectId 之后，重新梳理动画关系
        editAnimateAddLayout(this.$store.state[this.request_prefix], this.newRectIds, this.id)
      }
      const lowerShape = rectAttr.shape.toLowerCase()
      if (rectAttr.shape === "cxPageLayoutComponent") {
        // 如果是带标签的布局组件，里面的组件的id 需要处理
        this.addRectInPageLayoutComponent(rectAttr.options.layout, param.rects, rectAttr.rect_id)
      }
    },
    async addRectHandle(rectAttr) {
      // 如果当前数据中存在appId判断当前组件是否是系统保存好的样式
      if (rectAttr.options.myFetchParam?.appId || rectAttr.options.appId) {
        //更新appid
        const appId = rectAttr.options.appId ? rectAttr.options.appId : rectAttr.options.myFetchParam?.appId
        // 需要判断当前组件类型，如果是基于自由布局开发的搜索组件/导航菜单，需要特殊处理
        const isSearchComponent = rectAttr.options.pluginName?.includes("searchComponentPlugin")
        const isNavComponent = rectAttr.shape.toLowerCase().includes("nav")
        const res = await this.$styleToSaveModule(
          "31CB73E03E24BBFF",
          "临时",
          appId,
          false,
          isSearchComponent,
          isNavComponent
        )
        if (!!res.appId) {
          // 没有myfetchparam的组件 比如搜索组件 更新appId
          rectAttr.options.appId = res.appId
          const params = {
            containerID: this.id,
            data: rectAttr
          }
          this.$store.dispatch(this.request_prefix + "/addElement", params)
        }
      } else {
        const params = {
          containerID: this.id,
          data: rectAttr
        }
        this.$store.dispatch(this.request_prefix + "/addElement", params)
      }
    },
    styleCol() {
      var bodyW = document.body.clientWidth
      if (bodyW < 960) {
        this.col = 1
      } else if (bodyW < 1284 && bodyW >= 960) {
        this.col = 2
      } else if (bodyW < 1608 && bodyW >= 1284) {
        this.col = 3
      } else if (bodyW > 1608) {
        this.col = 4
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-title{
  padding: 0  200px 0 0;
  box-sizing: border-box;
}
.dialog-name{
  font-size: 16px;
  font-weight: 600;
  color: rgba(0,0,0,0.8);
  width: 200px;
}
::v-deep .el-dialog .el-dialog__headerbtn{
  top:19px;
}
::v-deep .search-inp{
  width: 400px;
  background-color: #F3F3F3;
  border:none;
  border-radius: 8px;
  .icon{
    color: rgba(0,0,0,0.4);
  }
  .el-input__suffix-inner{
    line-height: 30px;
    cursor: pointer;
  }
}
.empty-data {
  padding: 200px 0;
  font-size: 14px;
  text-align: center;
}
.icon-portal-loading1 {
  display: inline-block;
  transform: rotate(90deg);
  font-size: 24px;
  color: var(--topOperationAColor);
  vertical-align: middle;
  animation: rotation 1s linear infinite;
  &:before {
    color: var(--topOperationAColor);
  }
}
::v-deep .pageLayout-style {
  margin-top: 75px !important;
  border-radius: 8px;
}
::v-deep .pageLayout-style .el-dialog__body {
  padding: 0;
  box-sizing: border-box;
}
.left {
  width: 200px;
  padding: 16px;
  box-sizing: border-box;
  overflow-y: auto;
  border-right: 1px solid #ededed;
}
.list-box {
  display: flex;
  align-items: stretch;
  min-height: 200px;
  height: calc(100vh - 200px);
  flex-wrap: wrap;
}
.style-datas {
  padding: 12px;
  font-size: 0;
}
.style-data-li {
  position: relative;
  /*height: 150px;*/
  min-height: 44px;
  width: 300px;
  margin: 12px 4px;
  display: inline-block;
  background: #fff;
  border: 1px solid #dee0e3;
  box-shadow: 0px 4px 16px 4px rgba(0, 0, 0, 0.03), 0px 4px 8px rgba(0, 0, 0, 0.02),
  0px 2px 4px -4px rgba(0, 0, 0, 0.02);
  //border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  box-sizing: border-box;
  //&.active {
  //  outline: 1px solid var(--themeColor);
  //  border: 1px solid var(--themeColor);
  //}
  &:hover {
    box-shadow: 0 0 0 3px rgba(43, 103, 255, 0.8);
    .delete-icon {
      display: block;
    }
  }
  p {
    opacity: 1;
  }
  //img.checked {
  //  position: absolute;
  //  top: -1px;
  //  right: -1px;
  //}
  .img-box {
    width: 100%;
    /*height: 100%;*/
    //padding: 10px;
    box-sizing: border-box;
    background-color: rgba(245, 246, 248, 1);
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
    background-clip: padding-box;
    img {
      width: 100%;
      height: auto;
    }
  }
  .delete-icon {
    position: absolute;
    display: none;
    top: 8px;
    right: 8px;
    border-radius: 6px;
    width: 26px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    background-color: var(--rootBgColor);
    color: var(--iconColor);
    font-size: 12px;
    border:1px solid var(--inputBg);
  }
  p {
    background: rgba(255, 255, 255, 0.8);
    text-align: left;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    padding: 10px 0;
    box-sizing: border-box;
    color: var(--textColor);
  }
}
.right {
  flex: 1;
  height: 100%;
  background-color: rgba(245, 245, 245, 1);
  overflow: auto;
}
.left-types-list {
  .types-list-li {
    font-weight: 500;
    font-size: 14px;
    line-height: 40px;
    padding: 0 10px 0 16px;
    cursor: pointer;
    border-radius: 8px;
    margin-bottom: 4px;
    .types-list-li-content{
      white-space: nowrap; /*内容超宽后禁止换行显示*/
      overflow: hidden; /*超出部分隐藏*/
      text-overflow: ellipsis; /*文字超出部分以省略号显示*/
    }
    &:hover {
      background-color: #f0f2f7;
    }
    &.active {
      background: var(--themeColorSelectBg);
      color: var(--themeColor);
    }
    &:nth-child(1){
      position: relative;
    }
    &:nth-child(2){
      margin-top: 24px;
    }
  }
}
.template-info{
  padding: 0 16px;
  border-top: 1px solid rgba(233, 233, 233, 1);
}
.component-name-box{
  line-height: 20px;
  padding: 10px 0;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.4);
  text-align: right;
}
.topping-style{
  position: absolute;
  bottom: -12px;
  left: 16px;
  right: 10px;
  content: " ";
  border-bottom: 1px solid rgb(240, 240, 240);
}
@media screen and (min-width: 1921px) {
  ::v-deep .pageLayout-style.el-dialog {
    width: 1720px;
  }
  .style-data-li {
    width: 350px;
  }
}
@media screen and (min-width: 1608px) and (max-width: 1920px) {
  ::v-deep .pageLayout-style.el-dialog {
    width: 1520px;
  }
}
@media screen and (min-width: 1284px) and (max-width: 1607px) {
  ::v-deep .pageLayout-style.el-dialog {
    width: 1196px;
  }
}
@media screen and (min-width: 960px) and (max-width: 1283px) {
  ::v-deep .pageLayout-style.el-dialog {
    width: 872px;
  }
}
@media screen and (max-width: 959px) {
  ::v-deep .pageLayout-style.el-dialog {
    width: 548px;
  }
  ::v-deep .search-inp{
    width: 240px;
  }
  .dialog-title{
    padding-right: 130px;
  }
}
</style>
